// Mensajes programados (30-oct-2026): la tarjeta del anuncio con los mensajes que salen solos
// a cada reserva. Panel: components/Propiedades/ScheduledMessagesPanel.vue
export const scheduledMessages = {
  head: {
    title: "Mensajes programados",
    sub: "Lo que recibe el huésped, desde que reserva hasta después de irse.",
    new: "Nuevo mensaje",
  },
  loadError: "No se pudieron cargar los mensajes.",
  retry: "Reintentar",
  cancel: "Cancelar",
  noName: "Sin nombre",
  tabs: { mensajes: "Mensajes", proximos: "Próximos envíos", historial: "Historial" },
  stages: { antes: "Antes de llegar", durante: "Durante la estancia", despues: "Después de irse" },
  when: {
    entrada: "la entrada",
    salida: "la salida",
    sameDay: "El día de {momento}, a las {hora}",
    before: "{n} día antes de {momento}, a las {hora} | {n} días antes de {momento}, a las {hora}",
    after: "{n} día después de {momento}, a las {hora} | {n} días después de {momento}, a las {hora}",
  },
  channels: { email: "Correo", whatsapp: "WhatsApp", ota: "OTA" },
  origins: { all: "Todas", directa: "Directas", booking: "Booking", airbnb: "Airbnb", expedia: "Expedia", otras: "Otros canales" },
  status: {
    pendiente: "En proceso",
    enviado: "Enviado",
    en_cola: "Esperando que acepte",
    fallo: "No salió",
    sin_contacto: "Sin datos de contacto",
    cancelado: "Cancelado",
  },
  errors: {
    canal_reserva_no_encontrada: "El canal no encontró esta reserva. Puede que ya no exista o que su chat no esté disponible.",
    canal_sin_permiso: "El canal no autorizó el envío. Revisa la conexión de este alojamiento.",
    canal_no_responde: "El canal no respondió en ese momento.",
    canal_rechazo: "El canal no aceptó el mensaje.",
    whatsapp_numero_invalido: "El número no es válido o no tiene WhatsApp.",
    whatsapp_rechazo: "WhatsApp no aceptó el mensaje.",
    correo_fallido: "El correo no se pudo entregar.",
    envio_fallido: "No se pudo completar el envío.",
    envio_interrumpido: "El envío se interrumpió antes de terminar.",
    sin_telefono: "La reserva no tiene un teléfono válido.",
    sin_correo: "La reserva no tiene correo propio. El de las OTAs es un alias.",
    sin_chat_ota: "La reserva no viene de una OTA con chat.",
    mensaje_borrado: "El mensaje se eliminó antes de enviarse.",
    mensaje_desactivado: "El mensaje se desactivó antes de enviarse.",
    reserva_cancelada: "La reserva se canceló antes de enviarse.",
    alojamiento_no_existe: "El alojamiento ya no existe.",
    mensaje_vacio: "El mensaje quedó vacío.",
    ya_no_tocaba: "Cuando el huésped aceptó, ya no correspondía entregarlo.",
  },
  unitScope: {
    sub: "Solo para {name}. Lo del anuncio también le llega, salvo que aquí lo cambies o lo apagues.",
    inherited: "Del anuncio",
    replaces: "Reemplaza al del anuncio",
    removed: "Apagado en esta unidad",
    offInListing: "Apagado en el anuncio",
    differentIn: "Distinto en: {names}",
    customize: "Cambiar solo en esta unidad",
    turnOff: "No enviar «{name}» en esta unidad",
    confirmRestore: "¿Eliminar? Volverá a salir el del anuncio.",
    ownUnits: "Además, estas unidades tienen mensajes propios: {names}. Se editan desde cada unidad.",
    replaceHint: "Mismo nombre que uno del anuncio: en esta unidad saldrá este en su lugar.",
  },
  clone: {
    button: "Clonar",
    rowAction: "Clonar a otra propiedad o unidad",
    titleAll: "Clonar a otras propiedades o unidades",
    bring: "Traer de otra",
    bringTitle: "Traer mensajes de otra propiedad o unidad",
    bringNoun: "sus mensajes programados",
    titleOne: "Clonar «{name}»",
    subtitle: "Se copian el texto, las vías, los filtros y los archivos. Si allí hay un mensaje con el mismo nombre, se actualiza; los demás no se tocan. Los activos empezarán a enviarse a la hora local de cada propiedad.",
    nounAll: "el mensaje programado | los {n} mensajes programados",
    nounOne: "el mensaje «{name}»",
    done: "Copiado a {n} alojamiento: {nuevos} nuevos y {actualizados} actualizados. | Copiado a {n} alojamientos: {nuevos} nuevos y {actualizados} actualizados.",
    skipped: {
      limite: "{names}: ya tiene el máximo de mensajes y no cupo «{msgs}».",
      archivo: "{names}: falta un archivo de «{msgs}». Vuelve a subirlo aquí y clona otra vez.",
      error: "{names}: no se pudo copiar «{msgs}».",
    },
  },
  timeline: {
    booked: "Reserva confirmada",
    bookedHint: "Si reserva cuando un momento ya pasó, ese mensaje no se envía.",
    checkin: "Día de entrada",
    checkout: "Día de salida",
    use: "Usar",
    add: "+ Añadir mensaje aquí",
    offset: {
      sameDay: "Ese día",
      before: "{n} día antes | {n} días antes",
      afterCheckin: "{n} día después | {n} días después",
      beforeCheckout: "{n} día antes de salir | {n} días antes de salir",
      after: "{n} día después | {n} días después",
    },
  },
  presets: {
    week: { name: "Falta una semana", text: "Hola {nombre}, ya falta poco para tu estancia en {alojamiento}. Te esperamos el {entrada}. Si necesitas algo antes de llegar, escríbenos." },
    three: { name: "Prepara tu llegada", text: "Hola {nombre}, en 3 días te recibimos en {alojamiento}. Tu entrada es a partir de las {hora_entrada}. Aquí tienes todo lo de tu estancia: {enlace_portal}" },
    arrival: { name: "Hoy es tu llegada", text: "Hola {nombre}, hoy te esperamos en {alojamiento} a partir de las {hora_entrada}. ¡Buen viaje!" },
    firstNight: { name: "Primera noche", text: "Hola {nombre}, esperamos que ya estés instalado en {alojamiento}. ¿Todo bien? Si necesitas algo, responde a este mensaje." },
    lastDay: { name: "Día de salida", text: "Hola {nombre}, hoy termina tu estancia en {alojamiento}. Recuerda que la salida es hasta las {hora_salida}. Gracias por quedarte con nosotros." },
    after: { name: "Gracias por venir", text: "Hola {nombre}, gracias por tu estancia en {alojamiento}. Esperamos verte pronto de nuevo." },
  },
  row: {
    files: "{n} archivo | {n} archivos",
    sent: "{n} enviado | {n} enviados",
    queued: "{n} esperando",
    failed: "{n} sin salir",
    duplicate: "Duplicar",
    delete: "Eliminar",
    confirmDelete: "¿Eliminar este mensaje?",
    yesDelete: "Sí, eliminar",
    copyOf: "Copia de {name}",
  },
  upcoming: {
    arrives: "Entra el {fecha}",
    leaves: "Sale el {fecha}",
    note: "Lo que saldrá en los próximos 30 días con las reservas de hoy. Tachado: a esa reserva no se le puede llegar por esa vía.",
    empty: "No hay envíos previstos en los próximos 30 días.",
    when: "Cuándo",
    guest: "Huésped",
    message: "Mensaje",
    channels: "Vías",
    needsCheckin: "Solo si completa el check-in",
    noReach: "Sin datos para esta vía",
  },
  history: {
    empty: "Todavía no ha salido ningún mensaje.",
    when: "Fecha",
    result: "Resultado",
    prev: "Anterior",
    next: "Siguiente",
  },
  vars: {
    nombre: "Nombre",
    alojamiento: "Alojamiento",
    entrada: "Fecha de entrada",
    salida: "Fecha de salida",
    hora_entrada: "Hora de entrada",
    hora_salida: "Hora de salida",
    codigo: "Código de reserva",
    enlace_portal: "Enlace del portal",
    enlace_tienda: "Enlace de la tienda",
  },
  form: {
    newTitle: "Nuevo mensaje",
    editTitle: "Editar mensaje",
    name: "Nombre interno",
    namePh: "Ej.: Prepara tu llegada",
    when: "Cuándo se envía",
    type: { antes: "Antes de", dia: "El mismo día de", despues: "Después de" },
    days: "Días",
    reference: "Referencia",
    theDayOf: "Día de",
    anchor: { entrada: "La entrada", salida: "La salida" },
    time: "Hora",
    timeIn: "hora de {zone}",
    timeEach: "a la hora local de cada alojamiento: {zones}",
    noZone: "{names}: sin país definido no sabemos su hora, así que los mensajes no saldrán ahí. Indícalo en la ubicación del alojamiento.",
    localTime: "hora del alojamiento",
    duringHint: "Si la estancia es más corta y ese día el huésped ya no está, no se envía.",
    channels: "Por dónde se envía",
    channelShort: { email: "Solo con correo propio", whatsapp: "Plantilla si pasaron 24 h", ota: "Chat de la reserva" },
    previewShort: "Vista previa",
    previewFrom: "Mensaje de",
    channelHint: {
      email: "Solo en reservas con correo propio. El correo que dan las OTAs es un alias, así que ahí no sale.",
      whatsapp: "Si pasaron más de 24 h o no hay conversación, enviamos la plantilla de contacto y el mensaje le llega al aceptarla. Con un número falso no se envía nada.",
      ota: "Por el chat de la OTA, solo en reservas de ese canal. Los archivos van como enlace.",
    },
    bookings: "A qué reservas",
    onlyCheckin: "Solo si ya completó el check-in",
    message: "Mensaje",
    messagePh: "Escribe el mensaje que recibirá el huésped",
    translate: "Traducir a los demás idiomas",
    translating: "Traduciendo…",
    translated: "Traducido a los demás idiomas.",
    translatePartial: "{n} idiomas no se pudieron traducir. Revísalos.",
    storeHint: "La tienda interna necesita un check-in hecho; antes de eso, el enlace lleva al portal del huésped, desde donde se llega a ella. Con tienda externa, va directo.",
    fallbackHint: "Se envía en el idioma del huésped. Si ese idioma no está escrito, va en español o en el primero disponible.",
    subject: "Asunto del correo (opcional)",
    subjectPh: "Si lo dejas vacío: Mensaje de tu alojamiento",
    files: "Fotos, vídeos y documentos",
    addFile: "Añadir archivo",
    uploading: "Subiendo…",
    filesHint: "Fotos JPG o PNG hasta {img} MB, PDF hasta {pdf} MB, XML hasta {xml} MB y vídeos MP4 o 3GP (H.264) hasta {video} MB. WhatsApp no admite XML como archivo: ahí va como enlace. Por correo va adjunto.",
    fileTooBig: "«{name}» supera el límite de {max} MB.",
    uploadError: "No se pudo subir el archivo.",
    active: "Activo",
    inactive: "Desactivado",
    save: "Guardar",
    saving: "Guardando…",
    saved: "Mensaje guardado.",
    saveError: "No se pudo guardar. Inténtalo de nuevo.",
    errName: "Ponle un nombre al mensaje.",
    errChannels: "Elige al menos una vía de envío.",
    errTime: "Indica la hora de envío.",
    errText: "Escribe el mensaje en al menos un idioma.",
    preview: "Vista previa con datos de ejemplo",
    previewEmpty: "Aquí verás el mensaje.",
  },
};
